// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountProfileAutofillController from "./account_profile_autofill_controller"
application.register("account-profile-autofill", AccountProfileAutofillController)

import AutoModalController from "./auto_modal_controller"
application.register("auto-modal", AutoModalController)

import AutocompleteSelectController from "./autocomplete_select_controller"
application.register("autocomplete-select", AutocompleteSelectController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import CepLookupController from "./cep_lookup_controller"
application.register("cep-lookup", CepLookupController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import ContractFormController from "./contract_form_controller"
application.register("contract-form", ContractFormController)

import EventFormController from "./event_form_controller"
application.register("event-form", EventFormController)

import FieldMirrorController from "./field_mirror_controller"
application.register("field-mirror", FieldMirrorController)

import FilterFormController from "./filter_form_controller"
application.register("filter-form", FilterFormController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FunnelStepSortController from "./funnel_step_sort_controller"
application.register("funnel-step-sort", FunnelStepSortController)

import KanbanBoardController from "./kanban_board_controller"
application.register("kanban-board", KanbanBoardController)

import KanbanColumnController from "./kanban_column_controller"
application.register("kanban-column", KanbanColumnController)

import LandingController from "./landing_controller"
application.register("landing", LandingController)

import MaskController from "./mask_controller"
application.register("mask", MaskController)

import NotificationRuleFormController from "./notification_rule_form_controller"
application.register("notification-rule-form", NotificationRuleFormController)

import OrderFormController from "./order_form_controller"
application.register("order-form", OrderFormController)

import SignaturePadController from "./signature_pad_controller"
application.register("signature-pad", SignaturePadController)
